import { render } from "./PieChart.vue?vue&type=template&id=424a7b14"
import script from "./PieChart.vue?vue&type=script&lang=js"
export * from "./PieChart.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4197/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__